import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { ERRORTYPES, ENVIRONMENT } from '../constants';
import Styles from './captcha.module.scss';
import getEnvVariable from '../utils/environment';
import withAccountInputs from '../containers/withAccountInputsV1';
import { WriteSelectors } from './captcha-qa-hooks';
import { ReCaptchaV3 } from './ReCaptchaV3';

export function Captcha(props) {
  function handleCaptchaOnChange(recaptcha) {
    // Don't do anything when the captcha challenge expires
    if (recaptcha) {
      props.postRecaptcha(recaptcha);
      // Clearing the v3 recaptcha token causes the ReCaptchaV3 component to fetch a new one
      // This is needed to ensure the token doesn't expire
      props.setRecaptchaToken('');
    }
  }

  return (
    <>
      <div className={Styles.wrapper}>
        <div
          className={
            props.formInputs.captcha_errorType !== ERRORTYPES.NO_TYPE_SET &&
            props.formInputs.captcha_errorType
              ? `${Styles['signup-captcha']} ${Styles['captcha-error']}`
              : Styles['signup-captcha']
          }
          data-role="captcha-container"
        >
          <ReCAPTCHA
            sitekey={getEnvVariable(ENVIRONMENT.RECAPTCHA_SITE_KEY)}
            data-role="captcha"
            onChange={handleCaptchaOnChange}
            {...WriteSelectors.captchaCheckbox}
          />
          <p className="small error">{props.formInputs.captcha_errorType}</p>
        </div>
      </div>
      <ReCaptchaV3
        setRecaptchaToken={props.setRecaptchaToken}
        recaptchaToken={props.formInputs.recaptcha_token}
      />
    </>
  );
}

Captcha.propTypes = {
  postRecaptcha: PropTypes.func.isRequired,
  setRecaptchaToken: PropTypes.func.isRequired,
  formInputs: PropTypes.shape({
    captcha_errorType: PropTypes.string,
    recaptcha_token: PropTypes.string
  }).isRequired
};

const ConnectedCaptcha = withAccountInputs(Captcha);
export default ConnectedCaptcha;
